// Import: Middleware Action & Custom Types
import {
  CLEAN_POST_BIND_ASSISTED_ORDER,
  CLEAN_POST_BIND_ASSISTED_ORDER_ERROR,
} from '_models/redux/types';

// Action function
export const cleanPostBindAssistedOrderAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_POST_BIND_ASSISTED_ORDER,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_POST_BIND_ASSISTED_ORDER_ERROR,
    });
  }
};
